import * as React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { cn } from '../lib/utils';


export default function FolderPathButton({ folder, name, setCurrentFolder, moveFolder, moveModel }) {
        const [{ isOver }, drop] = useDrop(
            () => ({
              accept: 'ELEM',
              drop: (item: any, _monitor) => {
                if (item.type == 'FOLDER') {
                    moveFolder(item, folder);
                } else if (item.type == 'MODEL') {
                    moveModel(item, folder);
                }
              },
              collect: (monitor) => ({
                isOver: !!monitor.isOver()
              })
            }),
            [moveFolder, moveModel]
        )

        return (
            <div ref={drop}>
                <button
                    className={cn(
                        "px-2 py-1 rounded-md text-sm font-semibold transition-colors",
                        "text-slate-700 hover:text-primary hover:bg-primary/5",
                        isOver && "bg-primary/10 text-primary"
                    )}
                    onClick={(e) => {setCurrentFolder(folder); e.stopPropagation()}}
                >
                    {name}
                </button>
            </div>
        )
}
